(function () {
	// Localized variables kept in localizeddetails file
	const localizedJS = new localizedDetails();
	const glideSlider = new sliderGlide4i();
	const tooltips = new toolTips();
	const forms = new forms4i();
	const helpers = new formHelpers4i();
	const common = new commonDetails(glideSlider);
	const prodConfig = common.ProductConfig;
	const mainScroller = new mainImageScroller4i();
	const addItemToCart = new addToCart4i(common);
	const waitToLoad = new WaitToLoad4i();
	const prodAdhesives = new productAdhesives4i();
	const prodOptionalExtras = new optionalExtras4i();
	const prodInkColors = new productInkColors4i();
	const imprintColorDropdown = new imprintColorDropdown4i();
	
	const selBaseTrim = document.getElementById('selectedColorID');
	//todo use box in helpers JS
	const errorMessageBox = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3><ul class="ErrorMsgBox"><li></li></ul></div>';
	let prevQty = prodConfig.IsApparelItem ? document.getElementById("txtQty") ? document.getElementById("txtQty").value : "0" : document.getElementById("txtQty") ? document.getElementById("txtQty").innerHTML : "0";
	let processing = false;
	let qty;

	const init = function () {
		// separate files
		glideSlider.Init(common);
		prodAdhesives.Init(common);
		prodOptionalExtras.Init(common);
		prodInkColors.Init(common);
		mainScroller.Init();
		waitToLoad.Init();
		
		
		if (!prodConfig.IsSuspended) {
			imprintConfig4i.GetSummary(); // call this as early as possible
			glideSlider.SetUpSlider();
		}

		if (prodConfig.IsSingleShipItem) detailsSS.Init();
		if (common.IsGFeed) gFeed.SetUpProduct();
		if (common.BypassImpConfig) enableCartBtn();
		if ((prodConfig.AllProdImgs == 1 || prodConfig.EditID > 0) && document.querySelector(".step1")) enableStep1Btn();

		trackButtonClicks();

		let selectedColorID = selBaseTrim.value;
		if (selectedColorID != "") {
			let selectedColors = [].slice.call(document.getElementsByClassName('selectedColorID'));
			selectedColors.forEach(function (el, index, array) {
				if (el.value == selectedColorID) {
					setTimeout(() => { el.previousElementSibling.click(); }, 1200);
				}
			});
		}

		// initialize sizing events if they already exist on the page
		if (document.querySelector(".sizeInputs")) Sizing4i.UpdatePricingArea();

		if (document.getElementById('hypMoreDetails')) document.getElementById('hypMoreDetails').addEventListener("click", scrollToMoreDeets);
		if (document.querySelector('.btnAddToCart')) document.querySelector('.btnAddToCart').addEventListener('click', addToCartClick);
		if (!common.IsMobile) {
			let nextLinks = [].slice.call(document.querySelectorAll(".nextStep"));
			nextLinks.forEach((el) => {
				el.addEventListener("click", goToNextStep);
			});
		}
		window.addEventListener("resize", clearFloat);

		// separate file
		//const miniRating = new MiniRating4i();
		//miniRating.Init();

		// separate file
		// be sure to pass in the main image slider variable
		const imageZoom = new ImageZoom4i(mainScroller.Slider);
		imageZoom.Init();

		//separate file
		if (document.querySelector(".setupTooltip")) {
			const extraDetailsDialog = new ExtraDetailsDialog4i();
			extraDetailsDialog.Init(common);
		}

		// separate file
		if (document.querySelector(".faveLink")) {
			const checkIfFavorite = new CheckIfFavorite4i();
			checkIfFavorite.Init();
		}

		// separate file
		if (prodConfig.IsApparelItem) {
			const sizeChart = new sizeChart4i();
			sizeChart.Init();
		}

		if (document.getElementById("copyTabs")) {
			setTimeout(() => {
				const copyTabs = new tabs4i();
				copyTabs.init(document.getElementById("copyTabs"));
			}, 1200);
		}

		//if(baseExtrasPrice != 0 && extrasAmount != "0" && document.getElementsByClassName("oneColorOption")[0]) {
		//	document.getElementById("extrasRow").classList.remove("hide")
		//}

		checkSetEdit();
		artInfoDialog();
		setUpHashOptions();
		ProductColorScroller.SetUp();
		tooltips.init();
		MobileTweaks();
		clearFloat();
		glideSlider.CheckForSingleQtyBreak();
		
		
	};

	const trackButtonClicks = () => {
		let items = document.getElementsByClassName('SocialMediaButtons');
		for (var i = 0; i < items.length; i++) {
			items[i].addEventListener('click', trackSocialButtonClick);
		}

		const tabItems = document.getElementsByClassName('tabLink');
		for (let item of tabItems) {
			item.addEventListener('click', trackDetailsButtonClick);
		}
	};

	const ProductColorScroller = (function () {
		let prodColorSlider,
			init = () => {
				prodColorSlider = new tns({
					container: '.prodColorSlider',
					mouseDrag: true,
					prevButton: document.getElementById('prodColorPrev'),
					nextButton: document.getElementById('prodColorNext'),
					items: 2,
					gutter: 10,
					loop: false,
					lazyload: true,
					slideBy: "page",
					nav: false,
					responsive: {
						1024: {
							items: 5
						},
						700: {
							items: 4
						},
						480: {
							items: 3
						}
					}
				});
				if (document.querySelector(".prodColorSlider").parentNode.parentNode.previousElementSibling.classList.contains("tns-liveregion")) {
					document.querySelector(".prodColorSlider").parentNode.parentNode.previousElementSibling.setAttribute("role", "status");
				}

				return prodColorSlider;
			},
			setUp = () => {
				if (document.getElementById("productColorScroller")) init();
				if (document.getElementById("jumpToColor")) initJumpToColor();
				
				
				addEvents();
				
				const params = new URLSearchParams(window.location.search);

				if (params.has("color")) {
					 let paramcolor = params.get("color");

					 const colorEl = [...document.querySelectorAll(".imgBox")]
  						  .find(el => el.href?.endsWith(`${paramcolor}.jpg`));

					colorEl.click();
					let gotoindex = [...document.querySelectorAll('.imgBox')]
  									.findIndex(el => el.href.endsWith(`${paramcolor}.jpg`));
  					prodColorSlider.goTo(gotoindex);
				}
			},
			addEvents = () => {
				let imageColorChoices = [].slice.call(document.querySelectorAll(".imgBox"));
				imageColorChoices.forEach((el) => {
					el.removeEventListener("click", saveColor);
					el.addEventListener("click", saveColor);
				});
			},
			saveColor = e => {
				e.preventDefault();
				e.stopPropagation();
				let triggerImg = e.currentTarget;
				SaveProdColor(triggerImg);
				
				//if ((prodConfig.EditID > -1 && cartItemExtrasTotal != 0.0) || baseExtrasPrice != 0 && extrasAmount != "0") {
				//
				//	document.getElementById("extrasRow").classList.remove("hide")
				//
				//} 

			},
			/*rebuild = () => { 
				prodColorSlider.destroy();
				prodColorSlider.rebuild();
				addEvents();
			},*/
			initJumpToColor = () => {
				document.getElementById("productColors").removeEventListener("click", colorOptionsEvents);
				document.getElementById("productColors").addEventListener("click", colorOptionsEvents);
			},
			colorOptionsEvents = e => {
				if (e.target.id == "jumpToColor") {
					e.preventDefault();
					showColorList();
				} else if (e.target.classList.contains("colorOption") || e.target.id == "removeColorFilter") {
					e.preventDefault();
					jumpToColor(e.target);
				}
			},
			showColorList = () => {
				document.getElementById('colorOptions').style.display = "block";
				document.getElementById('colorOptions').setAttribute('aria-hidden', 'false');
				document.getElementById('selectBaseColor').style.display = "block";
				document.getElementById('selectBaseColor').setAttribute('aria-hidden', 'false');
				document.getElementById('prodColorCountContainer').style.display = "none";
				document.getElementById('prodColorCountContainer').setAttribute('aria-hidden', 'true');
				document.getElementById('productColorScroller').style.display = "none";
				document.getElementById('productColorScroller').setAttribute('aria-hidden', 'true');
				document.getElementById('jumpToColor').style.display = "none";
				document.getElementById('jumpToColor').setAttribute('aria-hidden', 'true');
				document.getElementById('colorOptions').querySelector('.colorOption').focus();
			},
			jumpToColor = triggerElement => {
				let chosenColorID = '',
					elementId;
				if (triggerElement == document.getElementById('removeColorFilter')) {
					chosenColorID = '-1';
				} else if (triggerElement.classList.contains('colorOption')) {
					elementId = triggerElement.id;
					chosenColorID = elementId.substring(11, elementId.indexOf('_')); // color ID is the number after "colorOption" and before the underscore
				} else {
					elementId = triggerElement.parentNode.id;
					chosenColorID = elementId.substring(11, elementId.indexOf('_'));
				}
				getColorScroller(chosenColorID);
			},
			getColorScroller = color => {
				let colorInfo = serialize(document.getElementById('productColors').getElementsByTagName('form')[0]) + '&chosenColorID=' + color;
				let data = new URLSearchParams(colorInfo).toString();

				prodColorSlider.destroy();
				document.getElementById('productColors').innerHTML = '<div class="marginTop40 marginBtm40"><div class="spinner paddingTop40 paddingBtm40" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>';


				fetch('/productmvc/productcoloroptions', {
					method: 'POST',
					body: data,
					headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'fetch' }
				}).then(function (response) {
					return (response.ok) ? response.text() : [];
				}).then(function (response) {
					document.getElementById('productColors').innerHTML = response;

					//ProductColorScroller.Rebuild();
					ProductColorScroller.SetUp();
					if (document.getElementById('removeColorFilter')) {
						document.getElementById('removeColorFilter').focus();
					} else {
						document.getElementById('jumpToColor').focus();
					}
				}).catch(function (error) {
					// place error handling here
				});
			};
		return {
			SetUp: setUp
		};
	})();

	const Sizing4i = (function () {
		let txtTimer = null;
		let events = e => {
			if (e.target.classList.contains("addMoreSizes")) {
				e.preventDefault();
				addSizes(e.target);
			} else if (e.target.classList.contains("clearAllSizes")) {
				e.preventDefault();
				clearSizes(e.target);
			}
		},
			keyEvents = () => {
				let sizingInputs = [].slice.call(document.querySelectorAll('.txtApparelQty'));
				sizingInputs.forEach((el) => {
					el.removeEventListener("keyup", validateSize);
					el.addEventListener("keyup", validateSize);

					el.removeEventListener("focusout", validateSize);
					el.addEventListener("focusout", validateSize);
				});
			},
			clearSizes = el => {
				common.FadeOut(document.querySelector('.moreSizes'));

				// let animation play
				setTimeout(() => {
					[].forEach.call(document.querySelector('.moreSizes').querySelectorAll('.txtApparelQty'), function (elem) {
						elem.value = '';
					});
					let newLabel = el.value.replace('Clear All', 'Add');
					el.value = newLabel;
					el.classList.remove('clearAllSizes');
					el.classList.add('addMoreSizes');
					common.CalcPrice();
				}, 400);
			},
			addSizes = el => {
				common.FadeIn(document.querySelector('.moreSizes'));

				let newLabel = el.value.replace('Add', 'Clear All');
				el.value = newLabel;
				el.classList.remove('addMoreSizes');
				el.classList.add('clearAllSizes');
			},
			removeValidation = () => {
				let sizingInputs = [].slice.call(document.querySelectorAll('.txtApparelQty'));
				sizingInputs.forEach((el) => {
					el.classList.remove("input-validation-error");
					el.removeAttribute('aria-invalid');
				});
			},
			validateSize = e => {
				let elem = e.currentTarget;
				removeValidation();

				if (common.IsNumeric(elem.value)) {
					let thisQty = 0;
					let qty1 = 0;
					let qty2 = 0;
					let sizingInputs = [].slice.call(document.querySelectorAll('.txtApparelQty'));

					sizingInputs.forEach((el) => {
						if (el.value !== "" && common.IsNumeric(el.value)) {
							thisQty += parseInt(el.value);
							if (el.classList.contains('sizingGroup1')) {
								qty1 += parseInt(el.value);
							} else {
								qty2 += parseInt(el.value);
							}
						}
					});

					verifyApparelMaxQty(qty1, qty2);

					let updateDelay = (thisQty < prodConfig.LowestQuantity) ? 750 : 600;
					txtTimer = setTimeout(() => {
						if (document.getElementById("GFeedPanel")) gFeed.HidePanel();

						let hiddenInput = document.getElementById('txtQty') ? document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0] : null;
						if (document.getElementById('txtQty') && hiddenInput != null) hiddenInput.parentNode.removeChild(hiddenInput);
						if (document.getElementById("pricingarea")) {
							document.getElementById("pricingarea").classList.remove("hide");
							document.getElementById("pricingarea").classList.add("displayFlex");
						}
						common.CalcPrice();

					}, updateDelay);

				} else {
					elem.value = '';
					elem.focus();
					return false;
				}
				return true;
			},
			verifyApparelMaxQty = (qty1, qty2) => {
				if (!common.Restrict24hrMaxQty) return { qty1, qty2 };

				var warningId = 'qtywarning';
				var existingAlert = document.getElementById(warningId);
				//var addToCartBtn = document.getElementsByClassName('btnAddToCart')[0];

				// Check if either quantity exceeds the limit
				glideSlider.SetGlide24HrLimit(qty1, qty2);

				// Remove the existing alert only if neither quantity exceeds the limit
				if (!common.Exceeds24hrQtyLimit && existingAlert) {
					existingAlert.remove();
					return { qty1, qty2 };
				}

				// Add a new alert if max quantity is exceeded and no alert exists
				if (common.Exceeds24hrQtyLimit) {
					if (!existingAlert) {
						if (document.activeElement.value !== '' && isNumeric(document.activeElement.value)) {
							var quantityErrorHtml = glideSlider.Get24Error(warningId);
							document.querySelector('.priceTblSizeChoice').insertAdjacentHTML('beforebegin', quantityErrorHtml);
						}
					}
					return { qty1, qty2 };
				}
				return { qty1, qty2 };
			},
			updatePricingArea = () => {
				if (prodConfig.EditID < 0 && common.IsGFeed) document.querySelector('.txtApparelQty').value = prodConfig.LowestQuantity;

				common.CalcPrice();

				if (prodConfig.HidePricing) {
					document.querySelector('.showp').classList.add('hide');
					document.querySelector('.showpm').classList.remove('hide');
				}

				if (common.IsGFeed) gFeed.UpdateInfo();

				if (document.getElementById("GFeedPanel")) gFeed.ShowHidePanel();

				document.getElementById("pnlSizing").removeEventListener("click", events);
				document.getElementById("pnlSizing").addEventListener("click", events);

				keyEvents();
			},
			selectedSizes = () => {
				let sizeHash = "";
				if (prodConfig.IsApparelItem) {
					let sizeOptions = [].slice.call(document.querySelectorAll(".sizeOptionQty"));
					sizeOptions.forEach((el) => {
						let sizeQty = el.getElementsByClassName('txtApparelQty')[0].value;
						if (sizeQty != '' && sizeQty != undefined && sizeQty != '0') {
							let saPID = el.getElementsByClassName('sizeAttrProdID')[0].value,
								saID = el.getElementsByClassName('sizeAttrID')[0].value,
								qty = el.getElementsByClassName('txtApparelQty')[0].value;

							sizeHash += saPID + '-' + saID + '-' + qty + '|';
						}
					});
				}
				return sizeHash;
			},
			fetchSizing = (basetrim) => {
				document.querySelector('.sizeGridLoadingImg').classList.remove('hide');

				let data = {
					ProductID: prodConfig.ID,
					Color: basetrim,
					EditID: prodConfig.EditID,
					HidePricing: prodConfig.HidePricing,
					BrandTagId: prodConfig.BrandTagId
				};

				fetch('/productmvc/loadsizeoptions', {
					method: 'POST',
					body: JSON.stringify(data),
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
				}).then(function (response) {
					return (response.ok) ? response.text() : [];
				}).then(function (response) {
					document.querySelector('.sizeGridLoadingImg').classList.add('hide');
					document.getElementById('SizingGrid').innerHTML = response;
					updatePricingArea(prodConfig.HidePricing);
				}).catch(function (error) {
					document.getElementById('SizingGrid').innerHTML = ('<div role="alert"aria-atomic="true" class="margin10 padding10 borderDkRed textDkRed clear">An error occured when looking up the available sizes. Please select ' + localizedJS.Color + ' again, or call us toll free at ' + localizedJS.PhoneNumber + ' for further assistance.</div>');
					document.querySelector('.sizeGridLoadingImg').classList.add('hide');
				});
			};

		return {
			FetchSizing: fetchSizing,
			SelectedSizes: selectedSizes,
			UpdatePricingArea: updatePricingArea
		};
	})();

	const gFeed = (function () {
		const showHidePanel = () => {
			document.getElementById('GFeedPanel').style.display = "block";
			if (document.getElementById("GFeedPanel").style.display == "block") {
				// apparel pricing is repeated, should be hidden until gfeed is hidden, then shown
				document.getElementById("pricingarea").classList.add("hide");
				document.getElementById("pricingarea").classList.remove("displayFlex");
			} else {
				document.getElementById("pricingarea").classList.remove("hide");
				document.getElementById("pricingarea").classList.add("displayFlex");
			}
		},
			showPanel = () => {
				document.getElementById('GFeedPanel').classList.add("hide");
				document.getElementById('GFeedPanel').style.display = "block";
				document.querySelector('.GFeedPanel1').remove();
			},
			hidePanel = () => {
				document.getElementById("GFeedPanel").style.display = "none";
			},
			addSummary = () => {
				var gFeedSummary = '<div class="GFeedPanel1 c-md-12">';
				gFeedSummary += document.getElementById('GFeedPanel').innerHTML + '</div>';
				document.getElementById('GFeedPanel').innerHTML = "";
				document.getElementById("PD_OptionalExtra").insertAdjacentHTML('afterend', gFeedSummary);
			},
			clearPanel = function () {
				if (document.getElementById('GFeedData')) {
					document.getElementById('GFeedData').style.display = 'none';
				}
			},
			setUpProduct = function () {
				if (!prodConfig.IsApparelItem) {
					setTimeout(() => {
						var imgBox = document.querySelector('.imgBox');
						if (imgBox) imgBox.click();
						if (!common.IsMobile && common.IsGFeed) gFeed.UpdateInfo();
					}, 1200);

					// these only appear if item is not suspended
					if (document.getElementById("litGlideTotal")) {
						// per shawn a - glide pricing should be hidden to avoid ad disapprovals
						document.getElementById("litGlideTotal").classList.add("hide");
						document.getElementById("lblQuantityTxtCaption").classList.add("hide");
						document.getElementsByClassName("glide")[0].lastElementChild.classList.add("hide"); //unit price 
						document.getElementsByClassName("glide")[0].lastElementChild.classList.remove("displayFlex"); //unit price      
					}
					//causes the extras to get added twice on mobile, think this is a good place to not run it twice
				} else if (prodConfig.AllProdImgs > 1) {
					document.getElementById('GFeedPanel').style.display = "none";
					setTimeout(function () {
						document.querySelector('.imgBox').click();
					}, 1200);
				} else if (prodConfig.AllProdImgs == 1) {
					if (document.getElementsByClassName('txtApparelQty')[0]) {
						document.getElementsByClassName('txtApparelQty')[0].value = prodConfig.LowestQuantity;
					}
					if (document.getElementById("pricingarea")) {
						document.getElementById("pricingarea").classList.add("hide");
						document.getElementById("pricingarea").classList.remove("displayFlex");
					}
					common.CalcPrice();
					if (common.IsGFeed) gFeed.UpdateInfo();
				}
				var productColorImgs = [].slice.call(document.getElementsByClassName("imgBox"));
				if (productColorImgs.length > 0) {
					setTimeout(function () {
						productColorImgs[0].click();
					}, 1200);
				}
			},
			updateInfo = () => {
				if (document.querySelector(".imprint-color-section")) common.UpdateRemoveColorText(document.querySelector(".imprint-color-section"));
				//let txtQty = common.GetQty();
				selBaseTrim.value = document.getElementsByClassName('selectedColorID')[0] ? document.getElementsByClassName('selectedColorID')[0].value : "";
				let glideUnitPrice = 0,
					glideTotal = 0,
					glideSubTotal = 0;

				glideUnitPrice = document.getElementById('lblPrice') ? document.getElementById('lblPrice').value : "";
				glideTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";
				glideSubTotal = document.getElementById('lblSubtotal') ? document.getElementById('lblSubtotal').innerHTML : "";

				if (document.getElementById('GFeedQty')) {
					//commenting these out as google's scraper sucks but not so much on the UK side
					if (!(common.UkTaxRate != '0')) {
						document.getElementById('GFeedQty').innerHTML = ''; //txtQty;
						document.getElementById('GFeedUnitPrice').innerHTML = ''; //glideUnitPrice;
						document.getElementById('GFeedTotalPrice').innerHTML = ''; //glideTotal;
					}
					if (document.getElementById('gFeedDefaultImprintColor')) {
						document.querySelector(".input_active").innerHTML = document.getElementById('gFeedDefaultImprintColor').parentNode.querySelector('.spnColorChip').innerHTML;
						document.querySelector(".input_active").querySelector(".colorOptionText").classList.add("txtToValidate");
						document.querySelector(".prodColorOptions").classList.remove("txtReq");
						document.querySelector(".colorOptions").classList.add("hide");
						document.querySelector(".colorOptions").removeAttribute("style");
						document.querySelector(".imprintClearColor").classList.remove("hide");
						saveImprintColor(document.getElementById('gFeedDefaultImprintColor').parentNode.querySelector('.spnColorChip'));
					}
				}
				if (prodConfig.HasNonSizingAttributes || prodConfig.HasOptionalExtras) getAttributes();
			},
			saveImprintColor = (triggerElement) => {
				var activeSection = triggerElement.closest(".imprintConfiguration");
				var selectedColor = triggerElement.querySelector('.colorOptionBox').style.backgroundColor;
				var colorTitle = triggerElement.getAttribute('title');
				var imprintLocID = triggerElement.parentNode.querySelector('.imprintLocationID').value;
				var imprintColorID = triggerElement.parentNode.querySelector('.imprintColorID').value;
				var productImprintLocationID = triggerElement.parentNode.querySelector('.productImprintLocationID').value;
				var oneColor = activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length == 1;
				var selectColorOptionsElem = triggerElement.closest(".prodColorOptions");
				var needToGetExtras = false;
				if (selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor == "" ||
					selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor == "rgba(0, 0, 0, 0)") {
					needToGetExtras = true;
				}
				var colorLists = [].slice.call(selectColorOptionsElem.querySelectorAll('.colorList'));
				var emptyColorBoxes = [];
				colorLists.forEach(function (el) {
					var rgbColor = el.querySelector('.imprintColorBox').style.backgroundColor;
					if (rgbColor == "rgba(0, 0, 0, 0)" || rgbColor == "transparent" || rgbColor == "") {
						emptyColorBoxes.push(el);
					}
				});
				if (emptyColorBoxes.length > 0 && !oneColor) {
					emptyColorBoxes[0].querySelector('.imprintLocationID').value = imprintLocID;
					emptyColorBoxes[0].querySelector('.imprintColorID').value = imprintColorID;
					emptyColorBoxes[0].querySelector('.productImprintLocationID').value = productImprintLocationID;
					emptyColorBoxes[0].querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
					emptyColorBoxes[0].querySelector('.imprintColorBox').setAttribute('title', colorTitle);
				} else if (colorLists.length > 0) {
					selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
					selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').setAttribute('title', colorTitle);
					selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintLocationID').value = imprintLocID;
					selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorID').value = imprintColorID;
					selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.productImprintLocationID').value = productImprintLocationID;
				}

				common.ValidateCustomizeSections();
				if (needToGetExtras) { // don't get extras if they're just changing colors among the same color option
					common.GetExtrasAmount();
				}

				setTimeout(function () {
					selectColorOptionsElem.focus();
				}, 200);
			};
		return {
			ShowHidePanel: showHidePanel,
			ShowPanel: showPanel,
			AddSummary: addSummary,
			ClearPanel: clearPanel,
			SetUpProduct: setUpProduct,
			HidePanel: hidePanel,
			UpdateInfo: updateInfo
		};
	})();

	const artInfoDialog = function () {
		if (document.getElementsByClassName('artInstLink')[0]) {
			const artInstDialog = new Dialog4i();
			const artDialogLinks = [].slice.call(document.querySelectorAll('.artInstLink'));
			const artInstContent =
				'<h3 class="textBlue textSemiBold">How do I upload my art files?</h3>' +
				'<p>Once you\'ve completed checking out, you will have the option to upload your art file(s). We gladly accept all file types.</p>' +
				'<p class="marginTop10">For text instead of a logo, enter it in the \'Additional Instructions\' box during checkout and mention it should be text only, or reply to the confirmation email after placing your order.</p>' +
				'<h3 class="textBlue textSemiBold marginTop10">What if I don\'t have my art files right now?</h3>' +
				'<p>No worries, the confirmation email you\'ll receive after ordering will have additional instructions.</p>';

			artInstDialog.Init({
				triggerElements: artDialogLinks,
				dialogClass: "mediumDialog",
				title: "Sending Us Your Artwork",
				content: artInstContent
			});
		}
	};

	const imprintConfig4i = (function () {
		const colorDropdownPlaceholder = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + "...</span>";
		const init = () => {
			var addImpColor = [].slice.call(document.getElementsByClassName("addImpColor"));
			addImpColor.forEach(function (el) {
				el.removeEventListener("click", bindAddImpColor);
				el.addEventListener("click", bindAddImpColor);
			});
			var delImpConfigSections = [].slice.call(document.getElementsByClassName("delImpConfigSection"));
			delImpConfigSections.forEach(function (el) {
				el.removeEventListener("click", bindDelImpConfigSection);
				el.addEventListener("click", bindDelImpConfigSection);
			});
			var addimpLocations = [].slice.call(document.getElementsByClassName("addImpLocation"));
			addimpLocations.forEach(function (el) {
				el.removeEventListener("click", bindAddImpLocations);
				el.addEventListener("click", bindAddImpLocations);
			});
			var impLocs = [].slice.call(document.getElementsByClassName("selImprintLocation"));
			impLocs.forEach(function (el) {
				el.removeEventListener("change", bindImpLocDropDowns);
				el.addEventListener("change", bindImpLocDropDowns);
			});
			var clearColor = [].slice.call(document.getElementsByClassName("imprintClearColor"));
			clearColor.forEach(function (el) {
				el.removeEventListener("click", bindClearImprintColor);
				el.addEventListener("click", bindClearImprintColor);
			});
		},
			bindAddImpColor = (e) => {
				gFeed.ClearPanel();
				forms.ClearValidation();
				if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
					document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
				}
				var el = e.target;
				var nextColorSection = el.closest(".imprintConfiguration").querySelector('.imprint-color-section.hide');
				var currentColorSection;
				if (nextColorSection) {
					var numSections = el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section").length - el.closest(".imprintConfiguration").querySelectorAll('.imprint-color-section.hide').length;
					currentColorSection = el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section")[numSections - 1];
				}
				if (currentColorSection != null && currentColorSection.querySelector(".input_active").querySelector(".input_placeholder")) {
					forms.ClearValidation();
					var elemToValidate = currentColorSection.querySelector(".txtReq");
					document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', errorMessageBox);
					if (prodConfig.ListSelectedColors.length == 0) {
						document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">Please select a product imprint ' + localizedJS.Color + '.</a>';
					} else {
						document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">Please select a product imprint ' + localizedJS.Color + ' before adding a new one.</a>';
					}
					document.getElementsByClassName("errorItem")[0].focus();
					currentColorSection.querySelector(".txtReq").classList.add("input-validation-error");
					currentColorSection.querySelector(".txtReq").setAttribute("aria-invalid", "true");
					currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").classList.remove("hide");
					currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").innerHTML = document.getElementsByClassName("errorItem")[0].innerHTML;
				} else {
					if (nextColorSection) {
						nextColorSection.classList.remove("hide");
						nextColorSection.querySelector(".prodColorOptions").classList.add("txtReq");
						nextColorSection.querySelector(".prodColorOptions").focus();
						nextColorSection.getElementsByClassName("imprintClearColor")[0].classList.remove("hide");
					}
					if (el.closest(".imprintConfiguration").querySelector(".imprintColorsCount").innerHTML == el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section").length - el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section.hide").length) {
						el.classList.add("hide");
					}
				}
			},
			bindDelImpConfigSection = (e) => {
				var el = e.target;
				forms.ClearValidation();
				var selectedOption = el.closest(".imprintConfiguration").getElementsByClassName("selImprintLocation")[0][el.closest(".imprintConfiguration").getElementsByClassName("selImprintLocation")[0].selectedIndex];
				el.parentNode.parentNode.parentNode.removeChild(el.parentNode.parentNode);
				var impConfigSections = document.getElementsByClassName("imprintConfiguration");
				var numSections = impConfigSections.length;
				impConfigSections[numSections - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
				impConfigSections[numSections - 1].getElementsByClassName("addImpLocation")[0].focus();
				let i;
				for (i = 0; i < numSections; i++) {
					var selectBox = impConfigSections[i].getElementsByClassName("selImprintLocation")[0];
					if (i != 0) {
						var impLocCounts = [].slice.call(impConfigSections[i].getElementsByClassName("impLocCount"));
						impLocCounts.forEach(function (el, index, array) {
							el.innerHTML = imprintConfig4i.GetLocationCountText(i);
						});
						if (numSections - 1 >= 1) {
							impConfigSections[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
							impConfigSections[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.add("displayFlex", "flexSpaceBetween");
						}
						setLocationCounts();
						var selectedIndex = selectBox.selectedIndex;
						var optionExists = false;
						for (var j = 0; j < selectBox.length; j++) {
							if (selectBox.options[j].value === selectedOption.value) {
								optionExists = true;
							}
						}
						if (!optionExists) {
							var option = document.createElement("option");
							option.text = selectedOption.textContent;
							option.value = selectedOption.value;
							selectBox.add(option);
							selectBox.selectedIndex = selectedIndex;
							if (selectBox.disabled && selectBox.options.length > 1) {
								selectBox.removeAttribute("disabled");
							}
						}
					}
				}
				if (prodConfig.ListSelectedColors.length > 0 || document.getElementsByClassName("imprint-color-section").length == 0) {
					common.GetExtrasAmount(); // add to the total
				}
			},
			bindAddImpLocations = (e) => {
				gFeed.ClearPanel();
				e.preventDefault();
				forms.ClearValidation();
				if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
					document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
				}
				var numColorSections = e.target.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section").length - e.target.closest(".imprintConfiguration").querySelectorAll('.imprint-color-section.hide').length;
				var currentColorSection = e.target.closest(".imprintConfiguration").getElementsByClassName("imprint-color-section")[numColorSections - 1];
				if (currentColorSection != undefined) {
					var titleText = "Please select a product imprint " + localizedJS.Color + " for the " + imprintConfig4i.GetLocationCountText(document.getElementsByClassName("imprintConfiguration").length - 1).toLowerCase() + " location.";
					currentColorSection.querySelector(".prodColorOptions").setAttribute("title", titleText);
					currentColorSection.querySelector(".input_active").setAttribute("title", titleText);
				}
				if (currentColorSection != null && currentColorSection.querySelector(".input_active").querySelector(".input_placeholder")) {
					document.querySelector('.formHeading').insertAdjacentHTML('afterend', errorMessageBox);
					var elemToValidate = currentColorSection.querySelector(".txtReq");
					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">' + elemToValidate.getAttribute("title") + '</a>';
					document.querySelector(".errorItem").focus();
					currentColorSection.querySelector(".txtReq").classList.add("input-validation-error");
					currentColorSection.querySelector(".txtReq").setAttribute("aria-invalid", "true");
					currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").classList.remove("hide");
					currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").innerHTML = currentColorSection.querySelector(".txtReq").getAttribute("title");
				} else {
					common.GetSelectedImprintLocations();
					e.target.classList.add("hide");
					getAddlImpConfigPage(prodConfig.ListImprintLocationIDs);
				}
			},
			bindImpLocDropDowns = (e) => {
				gFeed.ClearPanel();
				var locDropDown = e.target;
				var impConfigSection = locDropDown.closest(".imprintConfiguration");
				if (impConfigSection.querySelector(".impLocLoadingImg")) {
					impConfigSection.querySelector(".impLocLoadingImg").classList.remove("hide");
					impConfigSection.querySelector(".impLocLoadingOverlay").classList.remove("hide");
				}
				var impColorSections = impConfigSection.getElementsByClassName("imprint-color-section");
				let i;
				for (i = 0; i < impColorSections.length; i++) {
					if (impColorSections[i]) {
						if (i == 0 && !impColorSections[0].querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
							impConfigSection.querySelector(".prodColorOptions").classList.add("txtReq");
							if (impConfigSection == document.getElementsByClassName("imprintConfiguration")[0]) {
								impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + "...</span>";
							}
							else {
								impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + " for " + imprintConfig4i.GetLocationCountText(i + 1) + " Location ...</span>";
							}
						} else {
							impColorSections[i].classList.add("hide");
							if (i == impColorSections.length) {
								impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + common.ColorCapitalized + " for " + imprintConfig4i.GetLocationCountText(i) + " Location ...</span>";
							} else {
								impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + " for " + imprintConfig4i.GetLocationCountText(i) + " Location ...</span>";
							}
						}
						impColorSections[i].getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
						impColorSections[i].getElementsByClassName("imprintClearColor")[0].classList.add("hide");
						common.UpdateRemoveColorText(impColorSections[i]);
					}
				}
				locDropDown.id = "impLocation_" + locDropDown.value;
				locDropDown.parentNode.querySelector(".locSelectLabel").setAttribute("for", locDropDown.id);
				var impLocIDs = [].slice.call(impConfigSection.querySelectorAll('.imprintLocationID'));
				impLocIDs.forEach(function (impLocIDsElem) {
					impLocIDsElem.value = locDropDown.value;
				});
				var impLocDropDowns = [].slice.call(document.getElementsByClassName("selImprintLocation"));
				impLocDropDowns.forEach(function (element, index) {
					var duplicate = false;
					if (element[element.selectedIndex].text == locDropDown[locDropDown.selectedIndex].text && element != locDropDown) {
						duplicate = true;
						var allProdColorContainers = [].slice.call(impConfigSection.querySelectorAll(".colorOptionsContainer"));
						allProdColorContainers.forEach(function (elem) {
							elem.classList.remove("hide");
						});
						impConfigSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + " for " + imprintConfig4i.GetLocationCountText(index) + " Location ...</span>";
					}
					if (document.getElementsByClassName("imprintConfiguration").length > 1 && duplicate) {
						element.parentNode.parentNode.parentNode.removeChild(element.parentNode.parentNode);
						var numSections = document.getElementsByClassName("imprintConfiguration").length;
						document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
						for (i = 0; i < numSections; i++) {
							if (i != 0) {
								var impLocCounts = [].slice.call(document.getElementsByClassName("imprintConfiguration")[i].getElementsByClassName("impLocCount"));
								impLocCounts.forEach(function (el, index, array) {
									el.innerHTML = imprintConfig4i.GetLocationCountText(i);
								});
								if (numSections - 1 >= 1) {
									document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
									document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.add("displayFlex", "flexSpaceBetween");
								}
							}
						}
					}
					if (duplicate) {
						setLocationCounts();
					}
				});
				setLocationCounts();
				common.GetExtrasAmount(true);
				common.GetSelectedImprintLocations();
				updateLocationDetails(prodConfig.ListImprintLocationIDs, locDropDown);
				var locationLabels = [].slice.call(document.querySelectorAll(".impColorSelectLabel"));
				locationLabels.forEach(function (elem, index, array) {
					var colId = elem.nextElementSibling.firstElementChild.firstElementChild.querySelector(".colorOptionId") ? elem.nextElementSibling.firstElementChild.firstElementChild.querySelector(".colorOptionId").innerHTML : "0";
					elem.id = "impLocLbl_" + locDropDown.value + "_Color_" + colId + "_" + index;
					elem.nextElementSibling.firstElementChild.setAttribute("aria-labelledby", elem.id);
				});
				var colorDropDowns = [].slice.call(document.querySelectorAll(".prodColorOptions"));
				colorDropDowns.forEach(function (elem, index, array) {
					var colId = elem.firstElementChild.querySelector(".colorOptionId") ? elem.firstElementChild.querySelector(".colorOptionId").innerHTML : "0";
					elem.id = "impLoc_" + locDropDown.value + "_Color_" + colId + "_" + index;
				});
				common.ValidateCustomizeSections();
			},
			bindClearImprintColor = (e) => {
				gFeed.ClearPanel();
				e.preventDefault();
				var el = e.target;
				el.parentNode.getElementsByClassName('colorList')[0].querySelector('.selectedColor').style.backgroundColor = "rgba(0, 0, 0, 0)";
				el.parentNode.getElementsByClassName('colorList')[0].querySelector('.selectedColor').setAttribute('title', 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker');
				el.parentNode.getElementsByClassName('colorList')[0].querySelector('.imprintColorID').value = "";
				var activeSection = el.closest(".imprintConfiguration");
				var activeSectionNum = activeSection.querySelector(".impLocCount").innerHTML;
				if (!el.previousElementSibling.querySelector(".input_active").querySelector(".input_placeholder")) {
					var colorOptionId = el.previousElementSibling.querySelector(".input_active").querySelector(".colorOptionId").innerHTML;
					var allProdColors = [].slice.call(activeSection.querySelectorAll(".prodColorOptions"));
					allProdColors.forEach(function (elem) {
						if (elem.getElementsByClassName("colorId_" + colorOptionId)[0])
							elem.getElementsByClassName("colorId_" + colorOptionId)[0].classList.remove("hide");
						else if (elem.getElementsByClassName("colorId_0")[0])
							elem.getElementsByClassName("colorId_0")[0].classList.remove("hide");
					});
				}
				var colorSection = el.closest(".imprint-color-section");
				colorSection.getElementsByClassName("colorOptions")[0].classList.add("hide");
				colorSection.getElementsByClassName("colorOptions")[0].removeAttribute("style");
				var maxImpColors = colorSection.querySelector(".imprintColorsCount").innerHTML;
				var newColorSection = colorSection;
				if (activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length == 1) { // indicates this is the first color option area
					newColorSection.getElementsByClassName("imprintClearColor")[0].classList.add("hide");
					var locationCountText = activeSection.getElementsByClassName("impLocCount")[0].innerHTML;
					newColorSection.querySelector(".prodColorOptions").classList.add("txtReq");
					if (newColorSection.parentNode == document.getElementsByClassName("imprintConfiguration")[0]) {
						newColorSection.getElementsByClassName("input_active")[0].innerHTML = colorDropdownPlaceholder;
					} else {
						newColorSection.getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + " for " + activeSectionNum + " Location...</span>";
					}
					newColorSection.querySelector(".prodColorOptions").setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
					if (maxImpColors > 1) {
						activeSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
					}
					if (prodConfig.ListSelectedColors.length == 0 && parseInt(document.getElementById("BaseExtra").value) == 0) {
						document.getElementsByClassName("extrasRow")[0].classList.add("hide");
						document.getElementsByClassName("extrasResult")[0].innerHTML = "0.00";
						document.getElementsByClassName("currencySymbol")[0].classList.remove("hide");
					} else if (prodConfig.ListSelectedColors.length == 0 && parseInt(document.getElementById("BaseExtra").value) > 0) {
						document.getElementsByClassName("extrasResult")[0].innerHTML = parseFloat(document.getElementById("BaseExtra").value).toFixed(2);
					}
					newColorSection.querySelector(".prodColorOptions").focus();
				} else { // not the first color option area 
					if (activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length > 1 && newColorSection == activeSection.getElementsByClassName("imprint-color-section")[0]) {
						activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".impColorSelectLabel").innerHTML = "What imprint " + localizedJS.Color + "(s) would you like?<span> (Maximum # imprint colors: <span class='imprintColorsCount'>" + maxImpColors + "</span>)</span>";
						if (activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".input_placeholder")) {
							activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + "...</span>";
							activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".imprintClearColor").classList.add("hide");
						}
					} else {
						colorSection.parentNode.removeChild(colorSection);
					}
					newColorSection.getElementsByClassName("impColorSelectLabel")[0].innerHTML = "Select an additional imprint " + localizedJS.Color + "<span> (Maximum # imprint colors: <span class='imprintColorsCount'>" + maxImpColors + "</span>)</span>";
					activeSection.getElementsByClassName('imprint-color-section')[activeSection.getElementsByClassName('imprint-color-section').length - 1].insertAdjacentElement('afterend', newColorSection);
					newColorSection.classList.add("hide");
					if (newColorSection.parentNode == document.getElementsByClassName("imprintConfiguration")[0]) {
						newColorSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + common.ColorCapitalized + "...</span>";
					} else {
						newColorSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + common.ColorCapitalized + " for " + activeSectionNum + " Location...</span>";
					}
					var numColorSections = activeSection.querySelectorAll(".imprint-color-section").length - activeSection.querySelectorAll(".imprint-color-section.hide").length;
					el.parentNode.querySelector(".prodColorOptions").classList.remove("txtReq");
					activeSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
					activeSection.querySelectorAll(".imprint-color-section")[numColorSections - 1].querySelector(".prodColorOptions").focus();
				}
				let i;
				for (i = 0; i < activeSection.querySelectorAll(".imprint-color-section").length; i++) {
					if (activeSection.querySelectorAll(".imprint-color-section")[i]) {
						common.UpdateRemoveColorText(activeSection.querySelectorAll(".imprint-color-section")[i]);
					}
				}
				common.GetSelectedImprintColors();
				if (prodConfig.ListSelectedColors.length > 0) {
					common.GetExtrasAmount();
				}

				//if (listSelectedColors.length == 0) {
				//	document.getElementById("extrasRow").classList.add("hide")
				//}

				common.ValidateCustomizeSections();
			},
			updateLocationDetails = (selectedLocationIds, elem) => {
				let data = {
					SelectedLocIDs: selectedLocationIds,
					ImpLocID: elem.value,
					EditID: prodConfig.EditID,
					CatalogAlias: prodConfig.Alias
				};
				fetch('/productmvc/getimplocationdetails', {
					method: 'POST',
					body: JSON.stringify(data),
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": helpers.HeaderToken, 'RequestVerificationToken': helpers.HeaderToken }
				}).then(function (response) {
					return (response.ok) ? response.json() : []; // response.json() returns a promise
				}).then(function (response) {
					let imprintConfigSection;
					let i;
					if (response.success != undefined && response.maxColors != undefined && response.imprintLocations != undefined && response.identicalColorPalettes != undefined) {
						imprintConfigSection = elem.closest('.imprintConfiguration');
						var imprintColorsCount = [].slice.call(imprintConfigSection.getElementsByClassName("imprintColorsCount"));
						if (imprintConfigSection.querySelector(".imprint-color-section")) {
							imprintConfigSection.getElementsByClassName("imprint-color-section")[0].classList.remove("hide");
						}
						imprintColorsCount.forEach(function (el) {
							el.innerHTML = response.maxColors;
							if (response.maxColors > 1) {
								el.parentNode.classList.remove("hide");
							} else {
								el.parentNode.classList.add("hide");
							}
						});
						if (response.maxColors == 1 || response.maxColors == (imprintConfigSection.getElementsByClassName("imprint-color-section").length - imprintConfigSection.querySelectorAll(".imprint-color-section.hide").length)) {
							if (imprintConfigSection.getElementsByClassName("addImpColor")[0]) {
								imprintConfigSection.getElementsByClassName("addImpColor")[0].classList.add("hide");
							}
							if (response.numColorsOptionsAvailable == 1) {
								imprintConfigSection.querySelector(".spnColorChip").dispatchEvent(new MouseEvent('mousedown'));
							}
						} else if (response.maxColors == 0) {
							imprintConfigSection.getElementsByClassName("imprint-color-section")[0].classList.add("hide");
						} else {
							imprintConfigSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
						}
						if (response.isExcl) {
							if (imprintConfigSection.parentNode.getElementsByClassName("imprintConfiguration").length > 1) {
								var impConfigs = [].slice.call(document.getElementsByClassName("imprintConfiguration"));
								impConfigs.forEach(function (elem, index, array) {
									if (elem != document.getElementsByClassName("imprintConfiguration")[0]) {
										elem.parentNode.removeChild(elem);
									}
								});
							}
							if (imprintConfigSection.getElementsByClassName("addImpLocation")[0]) {
								imprintConfigSection.getElementsByClassName("addImpLocation")[0].classList.add("hide");
							}
							imprintConfigSection.getElementsByClassName("inputIsExcl")[0].value = "true";
						} else {
							if (document.getElementsByClassName("imprintConfiguration")[document.getElementsByClassName("imprintConfiguration").length - 1].getElementsByClassName("addImpLocation")[0] && response.addlImpLocs) {
								document.getElementsByClassName("imprintConfiguration")[document.getElementsByClassName("imprintConfiguration").length - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
							}
							imprintConfigSection.getElementsByClassName("inputIsExcl")[0].value = "false";
						}
						if (!response.identicalColorPalettes) {
							imprintConfigSection.getElementsByClassName("input_active")[0].innerHTML = colorDropdownPlaceholder;
							if (imprintConfigSection.getElementsByClassName("colorOptions")[0]) {
								var imprintLocationID = imprintConfigSection.getElementsByClassName("colorOptions")[0].querySelector(".imprintLocationID").value;
								var productImprintLocationID = imprintConfigSection.getElementsByClassName("colorOptions")[0].querySelector(".productImprintLocationID").value;
								var colorOptionContainers = [].slice.call(imprintConfigSection.getElementsByClassName("colorOptionsContainer"));
								colorOptionContainers.forEach(function (el) {
									el.parentNode.removeChild(el);
								});
								var newDiv = "";
								for (i = 0; i < response.colorPalette.length; i++) {
									newDiv += '<div class="colorOptionsContainer colorId_' + response.colorPalette[i].ImprintColorID + '"><button role="option" aria-selected="false" class="spnColorChip marginTop5 darkestLink text14 textLeft c-xs-full" title="' + response.colorPalette[i].ImprintColorDescription + '">';
									if (response.colorPalette[i].ImprintColorHex != "") {
										newDiv += '<span class="borderDkGray inlineMiddle colorOptionBox" style="background-color: #' + response.colorPalette[i].ImprintColorHex + '"></span>';
									}
									newDiv += '<span class="colorOptionText paddingLeft10 inlineMiddle"><span class="colorOptionDesc"> ' + response.colorPalette[i].ImprintColorDescription +
										'</span><span class="colorOptionId visually-hidden">' + response.colorPalette[i].ImprintColorID + '</span></span></button>';
									newDiv += '<input class="imprintLocationID" type="hidden" value="' + imprintLocationID + '" />';
									newDiv += '<input class="imprintColorID" type="hidden" value="' + response.colorPalette[i].ImprintColorID + '" />';
									newDiv += '<input class="productImprintLocationID" type="hidden" value="' + productImprintLocationID + '" /></div>';
								}
								var colorOptions = [].slice.call(imprintConfigSection.getElementsByClassName("colorOptions"));
								colorOptions.forEach(function (el) {
									el.insertAdjacentHTML('afterbegin', newDiv);
								});
								imprintColorDropdown.Init(common);
								var colorOptions2 = [].slice.call(imprintConfigSection.getElementsByClassName("colorOptions"));
								colorOptions2.forEach(function (el) {
									if (el.querySelectorAll(".colorOptionsContainer").length == 1) {
										el.parentNode.classList.add("disabledColorSelect");
										el.querySelector(".spnColorChip").dispatchEvent(new MouseEvent('mousedown'));
										el.closest(".colorDropDownContainer").getElementsByClassName("imprintClearColor")[0].classList.add("hide");
									} else {
										el.parentNode.classList.remove("disabledColorSelect");
									}
								});
							}
						}
						var originalDropDown = [].slice.call(document.getElementsByClassName("selImprintLocation")[0].options);
						var originalIndex = 0;
						for (i = 0; i < document.getElementsByClassName("selImprintLocation").length; i++) {
							var currentImpLocSelect = document.getElementsByClassName("selImprintLocation")[i];
							// Don't make any changes to the first select box or the one that was just changed 
							if (currentImpLocSelect != elem && currentImpLocSelect != document.getElementsByClassName("selImprintLocation")[0]) {
								var indexStart = [].slice.call(document.getElementsByClassName("selImprintLocation")).indexOf(elem);
								// Remove the option that was just selected from the other select boxes (but only any after it) 
								var oneJustSelected = elem[elem.selectedIndex];
								for (var j = 0; j < currentImpLocSelect.options.length; j++) {
									if (currentImpLocSelect.options[j].value == oneJustSelected.value) {
										if (i > indexStart) { // only remove the option that was just selected from the select boxes after the one you are changing 
											currentImpLocSelect.options.remove(currentImpLocSelect.options[j].index);
										}
									}
								}
								// Add the option that was deselected to the other select boxes 
								var listOfCurrent = [].slice.call(currentImpLocSelect.options);
								var valuesArr = [];
								listOfCurrent.forEach(function (el) {
									valuesArr.push(el.value);
								});
								var listOfNotSelected = [].slice.call(response.imprintLocations);
								var valuesArr2 = [];
								listOfNotSelected.forEach(function (el2) {
									var newObject = {};
									newObject.text = el2.ImprintLocationDescription;
									newObject.value = el2.ImprintLocationID.toString();
									valuesArr2.push(newObject);
								});
								valuesArr2.forEach(function (el3) {
									if (!valuesArr.includes(el3.value)) {
										var newElem = document.createElement("option");
										newElem.text = el3.text;
										newElem.value = el3.value;
										originalDropDown.forEach(function (el, index, array) {
											if (el.value == el3.value) {
												originalIndex = index;
											}
										});
										currentImpLocSelect.options.add(newElem, originalIndex);
									}
								});
								if (currentImpLocSelect.options.length > 1) {
									currentImpLocSelect.disabled = false;
								}
							}
						}
					} else { // error 
						if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
							document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
						}
						var loadingConfigSectionError = '<div id="ErrorBox" class="ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
							'<ul class="ErrorMsgBox"><li><div id="loadingError" class="textLeft text16 textLeft">An error has occurred.  Please refresh the page and try again.</div></li></ul></div>';
						document.querySelector('.formHeading').insertAdjacentHTML('afterend', loadingConfigSectionError);
					}
					if (imprintConfigSection.querySelector(".impLocLoadingImg")) {
						imprintConfigSection.querySelector(".impLocLoadingImg").classList.add("hide");
						imprintConfigSection.querySelector(".impLocLoadingOverlay").classList.add("hide");
					}
				}).catch(function (error) {
					// place error handling here
				});
			},
			getAddlImpConfigPage = (selectedLocationIds) => {
				document.getElementsByClassName("addImpLocLoadingImg")[selectedLocationIds.length - 1].classList.remove("hide");
				const params = 'selectedLocIDs=' + selectedLocationIds + '&EditID=' + prodConfig.EditID + '&catalogAlias=' + prodConfig.Alias;
				fetch('/productmvc/addlimpconfig?' + params, {
					method: 'GET',
					headers: { 'X-Requested-With': 'fetch' },
				}).then(function (response) {
					return (response.ok) ? response.text() : ""; // response.text() returns a promise
				}).then(function (response) {
					var impLocCount = selectedLocationIds.length;
					document.getElementsByClassName("imprintConfiguration")[impLocCount - 1].insertAdjacentHTML('afterend', response);
					var currentImpConfigSection = document.getElementsByClassName("imprintConfiguration")[impLocCount];
					var firstColorSection = currentImpConfigSection.getElementsByClassName("imprint-color-section")[0];
					document.getElementsByClassName("addImpLocLoadingImg")[impLocCount - 1].classList.add("hide");
					var impLocCounts = [].slice.call(currentImpConfigSection.getElementsByClassName("impLocCount"));
					impLocCounts.forEach(function (el) {
						el.innerHTML = imprintConfig4i.GetLocationCountText(impLocCount);
					});
					if (firstColorSection) {
						firstColorSection.getElementsByClassName("imprintClearColor")[0].classList.add("hide");
					}
					if (impLocCount > 1 && firstColorSection && !firstColorSection.querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
						firstColorSection.getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
					}
					if (impLocCount >= 1) {
						currentImpConfigSection.getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
						currentImpConfigSection.getElementsByClassName("impLocationCountHeader")[0].classList.add("displayFlex", "flexSpaceBetween");
					}
					if (currentImpConfigSection.getElementsByClassName("imprint-color-section").length > 1) {
						var imprintColorSections = [].slice.call(currentImpConfigSection.getElementsByClassName("imprint-color-section"));
						imprintColorSections.forEach(function (el, index) {
							if (index != 0) {
								el.getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
								el.classList.add("hide");
							}
						});
					}
					setLocationCounts();
					imprintColorDropdown.Init(common);
					imprintConfig4i.Init();
					imprintColorDropdown.KeyEvents();
					common.Step2ScrollBehavior(currentImpConfigSection, false);
					common.ValidateCustomizeSections();
					common.AccountForToMatchTrimImprintColors();
					common.GetExtrasAmount();
				}).catch(function (error) {
					//var impLocCount = selectedLocationIds.length;
					//var currentImpConfigSection = document.getElementsByClassName("imprintConfiguration")[impLocCount - 1];
					if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
						document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
					}
					var loadingConfigSectionError = '<div id="ErrorBox" class="ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
						'<ul class="ErrorMsgBox"><li><div id="loadingError" class="textLeft text16 textLeft">An error has occurred.  Please refresh the page and try again.</div></li></ul></div>';
					document.querySelector('.formHeading').insertAdjacentHTML('afterend', loadingConfigSectionError);

					document.querySelector(".addImpLocLoadingImg ").classList.add("hide");

				});
			},
			getSummary = () => {
				if (document.getElementsByClassName("goToStep1")[0]) {
					document.getElementsByClassName("goToStep1")[0].focus();
					document.getElementsByClassName('goToStep1')[0].scrollIntoView({
						behavior: "smooth"
					});
				}
				fetch('/productmvc/impconfigsummary' + window.location.search, {
					method: 'POST',
					credentials: 'include',
					mode: 'cors',
					body: JSON.stringify({
						'EditID': prodConfig.EditID,
						'CatalogAlias': prodConfig.Alias
					}),
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': helpers.HeaderToken, 'RequestVerificationToken': helpers.HeaderToken }
				}).then(function (response) {
					if (response.ok) {
						return response.text();
					} else {
						document.querySelector(".impConfigLoadingImg").classList.add("hide");
						document.querySelector(".impConfigLoadingError").classList.remove("hide");
						return "";
					}
					//return (response.ok) { response.text() : ""; // response.text() returns a promise
				}).then(function (response) {
					if (document.getElementById("imprintLocations") || document.getElementsByClassName("bypassImpConfigAddToCart")[0]) {
						if (document.getElementsByClassName("impConfigLoadingImg")[0]) {
							document.getElementsByClassName("impConfigLoadingImg")[0].classList.add("hide");
						}
						if (document.getElementById("imprintLocations")) {
							document.getElementById("imprintLocations").insertAdjacentHTML("afterend", response);
						} else {
							document.getElementsByClassName("attributesLoadingImg")[0].parentNode.parentNode.getElementsByClassName("formHeading")[0].insertAdjacentHTML("afterend", response);
						}
						forms.ClearValidation();
						imprintConfig4i.Init();
						imprintColorDropdown.Init(common);
						imprintColorDropdown.KeyEvents();
						setLocationCounts();
						common.ValidateCustomizeSections();
						if (common.IsGFeed) gFeed.UpdateInfo();
						common.Step2ScrollBehavior(document, true);
						if (prodConfig.HasNonSizingAttributes || prodConfig.HasOptionalExtras) getAttributes();
						if (common.ConfigSectionLoading) {
							common.ConfigSectionLoading = false;
							document.getElementsByClassName("btnAddToCart")[0].click();
						}
						if (common.ConfigSectionLoadingExtraChg) {
							common.ConfigSectionLoadingExtraChg = false;
							document.getElementsByClassName("setupTooltip")[0].click();
						}
						if (prodConfig.IsSingleShipItem && document.getElementsByClassName("btnConfigureSSBoxes")[0]) {
							detailsSS.Disable();
						}
						common.AccountForToMatchTrimImprintColors();
					}
				}).catch(function (response) {
					document.querySelector(".impConfigLoadingImg").classList.add("hide");
					document.querySelector(".impConfigLoadingError").classList.remove("hide");
				});
			},
			setLocationCounts = () => {
				var impConfigSections = document.getElementsByClassName("imprintConfiguration");
				for (var i = 0; i < impConfigSections.length; i++) {
					var locationCountText = imprintConfig4i.GetLocationCountText(i);
					var impLocCounts = [].slice.call(impConfigSections[i].getElementsByClassName("impLocCount"));
					impLocCounts.forEach(function (el, index, array) {
						el.innerHTML = locationCountText;
					});
					if (impConfigSections[i].getElementsByClassName("impLocCount")[0].innerHTML == "First") {
						impConfigSections[i].getElementsByClassName("impLocationCountHeader")[0].classList.add("hide");
						impConfigSections[i].getElementsByClassName("impLocationCountHeader")[0].classList.remove("displayFlex", "flexSpaceBetween");
					}
					if (impConfigSections[i].getElementsByClassName("imprint-color-section").length > 0) {
						var prodColorOpts = [].slice.call(impConfigSections[i].querySelectorAll(".prodColorOptions"));
						prodColorOpts.forEach(function (el) {
							el.setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
						});
						var activeInputs = [].slice.call(impConfigSections[i].querySelectorAll(".input_active"));
						activeInputs.forEach(function (el) {
							el.setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
						});
					}

					for (var j = 0; j < impConfigSections[i].querySelectorAll(".prodColorOptions").length; j++) {
						common.UpdateRemoveColorText(impConfigSections[i].querySelectorAll(".prodColorOptions")[j].parentNode.parentNode.parentNode);
						if (impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].querySelector(".input_placeholder")) {
							if (i == 0) {
								if (j == 0) {
									impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + "...</span>";
									impConfigSections[i].querySelectorAll(".prodColorOptions")[j].nextElementSibling.classList.add("hide");
								} else {
									impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + common.ColorCapitalized + "...</span>";
								}
							} else {
								if (j != 0) {
									impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + common.ColorCapitalized + " for " + imprintConfig4i.GetLocationCountText(i) + " Location ...</span>";
								} else {
									impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + common.ColorCapitalized + " for " + imprintConfig4i.GetLocationCountText(i) + " Location ...</span>";
								}
							}
						}
					}
				}
			},
			getLocationCountText = (locationCount) => {
				var imprintLocationCountText = "";
				switch (locationCount) {
					case 0:
						imprintLocationCountText = "First";
						break;
					case 1:
						imprintLocationCountText = "Second";
						break;
					case 2:
						imprintLocationCountText = "Third";
						break;
					case 3:
						imprintLocationCountText = "Fourth";
						break;
					case 4:
						imprintLocationCountText = "Fifth";
						break;
					case 5:
						imprintLocationCountText = "Sixth";
						break;
					case 6:
						imprintLocationCountText = "Seventh";
						break;
					case 7:
						imprintLocationCountText = "Eighth";
						break;
					case 8:
						imprintLocationCountText = "Ninth";
						break;
					case 9:
						imprintLocationCountText = "Tenth";
						break;
					case 10:
						imprintLocationCountText = "Eleventh";
						break;
					case 11:
						imprintLocationCountText = "Twelfth";
						break;
					case 12:
						imprintLocationCountText = "Thirteenth";
						break;
					case 13:
						imprintLocationCountText = "Fourteenth";
						break;
					case 14:
						imprintLocationCountText = "Fifteenth";
						break;
					default:
						imprintLocationCountText = "";
						break;
				}
				return imprintLocationCountText;
			};
		return {
			Init: init,
			GetLocationCountText: getLocationCountText,
			GetSummary: getSummary
		};
	})();

	const serialize = function (form) {
		/*!
		 * Serialize all form data into a query string
		 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
		 * @param  {Node}   form The form to serialize
		 * @return {String}      The serialized form data
		 */
		// Setup our serialized data
		var serialized = [];
		// Loop through each field in the form
		let i;
		for (i = 0; i < form.elements.length; i++) {
			var field = form.elements[i];
			// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
			if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
			// If a multi-select, get all selections
			if (field.type === 'select-multiple') {
				for (var n = 0; n < field.options.length; n++) {
					if (!field.options[n].selected) continue;
					serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
				}
			}
			// Convert field data to a query string
			else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
				serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
			}
		}
		return serialized.join('&');
	};

	const trackSocialButtonClick = (e) => {
		//facebook doesn't have host, it's a new window popup
		var socialNetwork = "Facebook";
		var host = e.srcElement.host;

		/* if (host && host.includes("twitter")) {
			 socialNetwork = "Twitter";
		 } else if (host && host.includes("pinterest")) {
			 socialNetwork = "Pinterest";
		 }*/
		const st = typeof s_gi === 'function' ? s_gi(s.account) : ''; //this verifies global s tracker is available
		if (st) {
			st.clearVars();
			st.prop40 = socialNetwork;
			st.linkTrackVars = "prop40";
			st.tl(this, 'o', 'Details Social Media Icons');
		}
	};

	const trackDetailsButtonClick = (e) => {
		const detailName = e.target.getAttribute('data-content'); //Different buttons in data content clicked
		const st = typeof s_gi === 'function' ? s_gi(s.account) : ''; //this verifies global s tracker is available
		if (st) {
			st.clearVars();
			st.prop42 = detailName;
			st.linkTrackVars = "prop42";
			st.tl(this, 'o', 'Details Tabs');
		}
	};

	const enableCartBtn = () => {
		document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
		document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
		document.querySelector('.btnAddToCart').classList.add('bkgdGreen');
		document.querySelector('.btnAddToCart').classList.add('darkestLink');
	};

	const MobileTweaks = () => {
		if (common.IsMobile) {
			var social = document.querySelectorAll(".SocialMediaButtons"); //need to return a nodelist to work
			var beforeProdDetails = document.querySelectorAll(".prodDetails");

			beforeProdDetails[0].parentNode.insertBefore(social[0], beforeProdDetails[0]);

			//var relatedProds = document.querySelectorAll("#relatedProductsContainer");
			//var lastElement = document.querySelectorAll(".back-to-top");
			//lastElement[0].parentNode.insertBefore(relatedProds[0], lastElement[0]);

			//document.getElementsByClassName("PD_Step_1")[0].classList.remove("borderDkGray");
			if (common.BypassImpConfig && !prodConfig.IsSingleShipItem) {
				//if (document.getElementsByClassName("bypassImpConfigAddToCart")[0]) {
				//	document.getElementsByClassName("bypassImpConfigAddToCart")[0].parentNode.classList.remove("floatRight");
				//}
				if (document.getElementById("addToCart").querySelector(".borderBottomDkGray")) {
					document.getElementById("addToCart").querySelector(".borderBottomDkGray").classList.remove("borderBottomDkGray");
				}
			}
			if (document.getElementById("btnCustomizeImprint")) {
				document.getElementsByClassName("PD_Step_2")[0].classList.remove("hide");
				document.getElementById("Step1ArtworkAlertBox").classList.add("hide");
			} else {
				if (document.querySelector('.btnAddToCart')) {
					enableCartBtn();
				}
			}
			if (document.querySelector('.glidePanel') !== null) {
				document.getElementsByClassName('glidePanel')[0].classList.add('marginTop10');
				document.getElementsByClassName('glidePanel')[0].classList.remove('marginTop40');
			}
			if (document.getElementById("addToCart") && document.getElementById("addToCart").querySelector('.displayFlex')) {
				document.getElementById("addToCart").querySelector('.displayFlex').classList.add('flexJustifyCenter');
				document.getElementById("addToCart").querySelector('.displayFlex').classList.remove('margin15');
			}
			if (document.getElementsByClassName("extrasResult")[0]) {
				document.getElementsByClassName("extrasResult")[0].innerHTML = common.FormatMoney(parseFloat(document.getElementsByClassName("extrasResult")[0].innerHTML.replace(common.CurrencySymbol, '')));
			}
			var selectedProdColor = "";
			if (!prodConfig.IsSuspended) {
				if (document.getElementsByClassName("oneColorOption")[0]) {
					selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
				} else {
					selectedProdColor = document.getElementById("selColors").innerHTML;
				}
			}
			if (document.getElementsByClassName("prodColor")[0]) {
				document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
				if (document.getElementsByClassName("prodColor")[1]) {
					document.getElementsByClassName("prodColor")[1].innerHTML = document.getElementsByClassName("prodColor")[0].innerHTML;
				}
			}
			if (document.getElementsByClassName("quantitySummary")[0] && !prodConfig.IsApparelItem) {
				document.getElementsByClassName("quantitySummary")[0].innerHTML = common.GetQty();
				if (document.getElementsByClassName("quantitySummary")[1]) {
					document.getElementsByClassName("quantitySummary")[1].innerHTML = document.getElementsByClassName("quantitySummary")[0].innerHTML;
				}
			}
			if (prodConfig.IsSingleShipItem) {
				detailsSS.HideBoxes();
			}
		}
	};

	const isNumeric = (n) => {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};

	const SaveProdColor = (triggerElement) => {
		common.AccountForToMatchTrimImprintColors();
		forms.ClearValidation();
		var selectedImg;
		if (triggerElement.querySelector('img')) {
			selectedImg = triggerElement.querySelector('img').getAttribute('data-src');  // jag - use data-src attribute instead of src do to lazy loading
		} else if (triggerElement.getAttribute('src')) {
			selectedImg = triggerElement.getAttribute('src');
		} else if (triggerElement.getAttribute('data-lazy')) {
			selectedImg = triggerElement.getAttribute('data-lazy');
		} else if (prodConfig.RecolorAvailable) {
			selectedImg = triggerElement.parentNode.getAttribute('href').replace("rend/700", "rend/300");
		}
		var selectedBaseTrimID = "";
		var selectedColorName = "";
		var trimColorHex = "";
		var baseColorHex = "";
		mainScroller.GoToFirstSlide();
		var prodColorImgs = [].slice.call(document.querySelectorAll(".imgBox"));
		var newLabel;
		if (prodConfig.RecolorAvailable) {
			if (document.querySelector('.imgActive')) { // remove previous active image
				if (document.querySelector('.imgActive').hasAttribute("aria-label")) { /* can remove with next release*/
					newLabel = document.querySelector('.imgActive').getAttribute("aria-label").replace("Currently Selected", "Select");
					document.querySelector('.imgActive').setAttribute("aria-label", newLabel);
				} else { /* updated with release */
					document.querySelector('.imgActive').setAttribute("aria-selected", "false");
				}
				document.querySelector('.imgActive').classList.remove("imgActive");
			}
			if (triggerElement.hasAttribute("aria-label")) { /* can remove with next release*/
				newLabel = triggerElement.getAttribute("aria-label").replace("Select", "Currently Selected");
				triggerElement.setAttribute("aria-label", newLabel);
			} else { /* updated with release */
				triggerElement.setAttribute("aria-selected", "true");
			}
			triggerElement.classList.add('imgActive');
			triggerElement.focus();

			if (selectedImg) {
				document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("src", selectedImg.replace("rend/60", "rend/300"));
				if (document.getElementById('hypProdImg').querySelector('.mainProdImg').getAttribute("data-src")) document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("data-src", selectedImg.replace("rend/60", "rend/300"));
				document.getElementById('hypProdImg').setAttribute("href", selectedImg.replace("rend/60", "rend/700"));
				if (document.getElementById("thumbSelectImage_0")) {
					document.getElementById("thumbSelectImage_0").setAttribute("src", selectedImg.replace("rend/60", "rend/100")); //small thumbnail
				}
			}

			document.getElementById('colorSelected').value = triggerElement.getAttribute("title");
			selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
			document.getElementById('colorSummary').textContent = triggerElement.getAttribute('title');
			selectedColorName = triggerElement.parentNode.querySelector('.selectedColorName').value;
			baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
			trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
			if (document.getElementById("selectedTrimHex")) {
				document.getElementById('selectedTrimHex').value = trimColorHex;
			}
		} else {
			selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
			selectedColorName = triggerElement.parentNode.querySelector(".selectedColorName").value;
			baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
			trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
			if (document.getElementById("selectedTrimHex")) {
				document.getElementById('selectedTrimHex').value = trimColorHex;
			}
			prodColorImgs.forEach(function (el, index, array) {
				if (el.hasAttribute("aria-label")) { /* can remove with next release*/
					newLabel = el.getAttribute("aria-label").replace("Currently Selected", "Select");
					el.setAttribute("arial-label", newLabel);
				} else { /* updated with release */
					el.setAttribute("aria-selected", "false");
				}
				el.querySelector('.selectedImgDesc').classList.add('textDarkestGray');
				el.querySelector('.selectedImgDesc').classList.remove('bkgdBlue');
				if (el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
					el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textRed');
					el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textWhite');
				}
			});
			if (triggerElement.hasAttribute("aria-label")) { /* can remove with next release*/
				newLabel = triggerElement.getAttribute("aria-label").replace("Select", "Currently Selected");
				triggerElement.setAttribute("aria-label", newLabel);
			} else { /* updated with release */
				triggerElement.setAttribute("aria-selected", "true");
			}
			triggerElement.querySelector('.selectedImgDesc').classList.add('textWhite');
			triggerElement.querySelector('.selectedImgDesc').classList.add('bkgdBlue');
			triggerElement.querySelector('.selectedImgDesc').classList.remove('textDarkestGray');
			if (triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
				triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textWhite');
				triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textRed');
			}
		}

		if (document.getElementById('baseSpan')) {
			document.getElementById('baseSpan').style.backgroundColor = '#' + baseColorHex;
			document.getElementById('baseSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".baseColorName").value);
			document.getElementById("baseColorText").textContent = triggerElement.parentNode.querySelector(".baseColorName").value;
		}
		if (document.getElementById('trimSpan')) {
			document.getElementById('trimSpan').style.backgroundColor = '#' + trimColorHex;
			document.getElementById('trimSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".trimColorName").value);
			document.getElementById("trimColorText").textContent = triggerElement.parentNode.querySelector(".trimColorName").value;
		}

		if (selectedBaseTrimID != undefined && selectedBaseTrimID != "") {
			selBaseTrim.value = selectedBaseTrimID;
			document.getElementById('colorSelected').value = selectedColorName;
			document.getElementById('selColors').innerHTML = selectedColorName;
		}

		var selectedProdColor = "";
		if (document.getElementsByClassName("oneColorOption")[0]) {
			selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
		} else {
			selectedProdColor = document.getElementById("selColors").innerHTML;
		}
		if (document.getElementsByClassName("prodColor")[0]) {
			document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
			if (document.getElementsByClassName("prodColor")[1]) {
				document.getElementsByClassName("prodColor")[1].innerHTML = document.getElementsByClassName("prodColor")[0].innerHTML;
			}
		}
		if (!prodConfig.IsApparelItem) {
			if (document.querySelector('.step1')) {
				enableStep1Btn();
			} else if (common.BypassImpConfig && !prodConfig.IsSingleShipItem) {
				enableCartBtn();
			} else if (common.BypassImpConfig && prodConfig.IsSingleShipItem) {
				detailsSS.EnableBtn();
			}
			if (document.getElementsByClassName("quantitySummary")[0]) {
				document.getElementsByClassName("quantitySummary")[0].innerHTML = common.GetQty();
			}
			if (common.IsMobile) {
				if (common.IsGFeed) {
					gFeed.UpdateInfo();
					gFeed.AddSummary();
				}
				if (document.getElementsByClassName("imprintConfiguration")[0]) {
					common.GetExtrasAmount(true);
				}
				common.ValidateCustomizeSections();
			}

		}
		if (selectedBaseTrimID != '' && prodConfig.IsApparelItem) {
			//Load apparel size grid
			if (document.getElementById('PD_SizeGrid')) {
				document.getElementById('PD_SizeGrid').innerHTML = '';
			}
			if (document.getElementById('PD_SizeGridLoading')) {
				document.getElementById('PD_SizeGridLoading').style.display = "block";
			}
			if (document.querySelector('.PD_QuantityBtnCell')) {
				document.querySelector('.PD_QuantityBtnCell').querySelector('input').disabled = true; // Disables the qty button to keep it from opening multiple windows
				document.querySelector('.PD_QuantityBtnCell').style.opacity = "0.3";
			}

			Sizing4i.FetchSizing(selectedBaseTrimID);
			if (common.IsGFeed) gFeed.UpdateInfo();
		}
		if (prodConfig.HasNonSizingAttributes) {
			prodInkColors.GetOptions();
			prodAdhesives.GetOptions();
		}
	};

	const clearFloat = () => {
		//add margin to push details down
		if (window.innerWidth >= 800) { //is desktop
			var imageHeight;
			if (document.querySelector('.extraImgsBox')) {
				imageHeight = 370 + document.querySelector('.extraImgsBox').offsetHeight;
			} else {
				imageHeight = 370;
			}
			var infoHeight = document.getElementsByClassName('prodInfo')[0].offsetHeight;
			var summaryHeight;
			var ps = document.getElementsByClassName('prodSummary');
			if (ps !== null && ps.length > 0) summaryHeight = ps[0].offsetHeight;
			var infoSummary = infoHeight + summaryHeight;

			if (imageHeight > infoSummary) {
				var H = imageHeight - infoSummary;
				document.getElementsByClassName('prodSummary')[0].style.marginBottom = H;
			}
		} else if (window.innerWidth < 800 && document.getElementsByClassName('prodSummary')[0]) { //don't add the extra margin
			document.getElementsByClassName('prodSummary')[0].style.marginBottom = '20px';
		}
	};

	const enableStep1Btn = () => {
		document.querySelector(".step1").classList.remove("disabledBtn");
		document.querySelector(".step1").classList.add("bkgdBlue");
		document.querySelector(".step1").classList.add("whiteLink");
	};

	const goToNextStep = (e) => {
		if (e.type == 'keyup' && (e.keyCode != 13)) return;
		var currentElem = e.currentTarget;
		if (document.querySelectorAll('.errorMsgPanel')[0]) {
			var errorMsgs = [].slice.call(document.querySelectorAll('.errorMsgPanel'));
			errorMsgs.forEach(function (el, index, array) {
				if (el.parentNode) {
					el.parentNode.removeChild(el);
				}
			});
		}
		//var colorSelected = document.getElementById('colorSelected').value;
		var selectedColorID = selBaseTrim.value;
		var qty = common.GetQty();
		//var previousQty = qty;
		var priceEach = "";
		if (document.getElementById("lblPrice")) {
			if (document.querySelector(".glidePanel")) { //glide
				priceEach = document.getElementById("lblPrice").value;
			} else { //apparel
				priceEach = document.getElementById("lblPrice").innerHTML;
			}
		}
		//var grandTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";

		if (currentElem.classList.contains('step1')) {

			if (prodConfig.IsApparelItem && document.getElementById('SizingGrid').innerHTML.length > 0) {
				common.CalcPrice();
			}
			if (selectedColorID == undefined || selectedColorID == "") {
				if (prodConfig.RecolorAvailable) {
					document.querySelector('#productColorScroller').insertAdjacentHTML('beforebegin', errorMessageBox);
					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorScrollerError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
					document.getElementById("colorScrollerError").focus();
					document.getElementById("colorScrollerError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('productColorScroller').querySelectorAll('.imgBox')[0].focus();
					});
				} else {
					document.querySelector('.PD_ColorList').insertAdjacentHTML('beforebegin', errorMessageBox);
					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorListError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
					document.getElementById("colorListError").focus();
					document.getElementById("colorListError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('listView').querySelectorAll('.selectedImgDesc')[0].focus();
					});
				}
				return false;
			}

			var quantityErrorHtml = common.Exceeds24hrQtyLimit ? '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
				'<ul id="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp text16 underline textLeft">Maxmimum quantity for each group is ' + glideSlider.GetMaxBreak() + '.</button></li></ul></div>'
				:
				'<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
				'<ul id="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp text16 underline textLeft">Minimum quantity for this item is ' + prodConfig.LowestQuantity + '.</button></li></ul></div>';

			if (qty == isNaN || qty == undefined || qty == '0' || !common.IsNumeric(qty) || common.Exceeds24hrQtyLimit) {
				if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
				let qty1 = 0;
				let qty2 = 0;
				let thisQty = 0;
				let sizingInputs = [].slice.call(document.querySelectorAll('.txtApparelQty'));

				sizingInputs.forEach((el) => {
					if (el.value !== "" && common.IsNumeric(el.value)) {
						thisQty += parseInt(el.value);
						if (el.classList.contains('sizingGroup1')) {
							qty1 += parseInt(el.value);
						} else {
							qty2 += parseInt(el.value);
						}
					}
				});
				if (prodConfig.IsApparelItem && document.getElementById('PD_SizeGrid') && common.Restrict24hrMaxQty) {
					document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);

					var allQtyInputs = document.getElementsByClassName("txtApparelQty");
					for (var x = 0; x < allQtyInputs.length; x++) {
						if (allQtyInputs[x].value != '') {
							if ((qty1 > glideSlider.GetMaxBreak() && allQtyInputs[x].classList.contains('sizingGroup1')) ||
								(qty2 > glideSlider.GetMaxBreak() && !allQtyInputs[x].classList.contains('sizingGroup1'))) {
								allQtyInputs[x].classList.add("input-validation-error");
								allQtyInputs[x].setAttribute('aria-invalid', 'true');
							}
							document.getElementById("quantityError").focus();
							document.getElementById("quantityError").addEventListener("click", function (e) {
								e.preventDefault();
								allQtyInputs[0].focus();
							});
						}
					}

				} else if (document.querySelector('.glidePanel')) {
					document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
					document.getElementById('txtQty').classList.add("input-validation-error");
					document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
					document.getElementById("quantityError").focus();
					document.getElementById("quantityError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('txtQty').focus();
					});
				}

				return false;
			}

			if (qty < prodConfig.LowestQuantity) {
				if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));

				if (prodConfig.IsApparelItem && document.getElementById('PD_SizeGrid')) {
					document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
					var apparelInputs = document.getElementsByClassName("txtApparelQty");
					for (var y = 0; y < apparelInputs.length; y++) {
						if (apparelInputs[y].value != '') {
							apparelInputs[y].classList.add("input-validation-error");
							apparelInputs[y].setAttribute('aria-invalid', 'true');
							document.getElementById("quantityError").focus();
							document.getElementById("quantityError").addEventListener("click", function (e) {
								e.preventDefault();
								apparelInputs[0].focus();
							});
						}
					}
				} else if (document.querySelector('.glidePanel')) {
					document.querySelector('.glidePanel').insertAdjacentHTML('afterend', quantityErrorHtml);
					document.getElementById('txtQty').classList.add("input-validation-error");
					document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
					document.getElementById("quantityError").focus();
					document.getElementById("quantityError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('txtQty').focus();
					});
				}
				return false;
			}

			if (qty >= prodConfig.LowestQuantity && selectedColorID != "") {
				if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
				document.getElementById('txtQty').classList.remove('input-validation-error');
				document.getElementById('txtQty').removeAttribute('aria-invalid');

				common.FadeOut(document.querySelector(".step1Color"));
				common.FadeOut(document.querySelector(".step1Qty"));

				setTimeout(() => {
					if (prodConfig.IsSingleShipItem && common.BypassImpConfig) {
						detailsSS.ConfigureBoxes();
					} else {
						common.FadeIn(document.querySelector(".PD_Step_2"));

						if (prodConfig.IsSingleShipItem) {
							detailsSS.Setup();
						}
						setTimeout(() => { // once step 2 is visible
							if (document.getElementsByClassName('ErrorMsgPanel')[0]) document.getElementsByClassName('ErrorMsgPanel')[0].remove();
							var selectedProdColor = "";
							if (document.getElementsByClassName("oneColorOption")[0])
								selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
							else
								selectedProdColor = document.getElementById("selColors").innerHTML;

							if (document.getElementsByClassName("prodColor")[0]) {
								document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
							}
							if (common.IsGFeed) {
								gFeed.UpdateInfo();
								if (document.getElementById('GFeedPanel')) {
									gFeed.AddSummary();
								}
								tooltips.init(); //gfeed tooltip
							}
							if (document.getElementsByClassName("imprintConfiguration")[0] && parseInt(document.getElementById("BaseExtra").value) != 0 && prevQty != qty) {
								prevQty = common.GetQty();
								common.GetExtrasAmount(true);
							} else if (document.getElementsByClassName("imprintConfiguration")[0]) {
								common.GetExtrasAmount(true);
							}
							document.getElementsByClassName("quantitySummary")[0].innerHTML = common.GetQty();
							if (prodConfig.HasNonSizingAttributes || prodConfig.HasOptionalExtras) getAttributes();
							common.Step2ScrollBehavior(document, false);
							common.AccountForToMatchTrimImprintColors();
						}, 200);
					}
				}, 400);
			}
		} else if (currentElem.classList.contains('goToStep1')) {
			if (document.getElementById('GFeedPanel')) {
				gFeed.ShowPanel();
			}

			common.FadeOut(document.querySelector(".PD_Step_2"));
			setTimeout(() => {
				common.FadeIn(document.querySelector(".step1Color"));
				common.FadeIn(document.querySelector(".step1Qty"));
			}, 400);

			setTimeout(function () { // once step 1 is visible
				if (!prodConfig.IsApparelItem) {
					document.getElementById("litGlideTotal").classList.remove("hide");
					document.getElementById("lblQuantityTxtCaption").classList.remove("hide");
					document.getElementsByClassName("glide")[0].lastElementChild.classList.remove("hide"); //unit price
					document.getElementsByClassName("glide")[0].lastElementChild.classList.add("displayFlex"); //unit price
					glideSlider.UpdateToolTip(); // added to update the tooltip position espeically with restricted pricing items
				}
				if (document.getElementById("pricingarea")) {
					document.getElementById("pricingarea").classList.remove("hide");
					document.getElementById("pricingarea").classList.add("displayFlex");
				}
				var selectedProdColor = "";
				if (document.getElementsByClassName("oneColorOption")[0]) {
					selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
				} else {
					selectedProdColor = document.getElementById("selColors").innerHTML;
				}
				document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
				document.getElementsByClassName("quantitySummary")[0].innerHTML = common.GetQty();

				document.getElementsByClassName('PD_Step_1')[0].scrollIntoView({
					behavior: "smooth"
				});
				if (document.getElementById("jumpToColor")) {
					document.getElementById("jumpToColor").focus();
				} else if (document.querySelector('.PD_Step_1').getElementsByTagName('a')[0]) {
					document.querySelector('.PD_Step_1').getElementsByTagName('a')[0].focus();
				} else {
					document.querySelector('.PD_Step_1').getElementsByTagName('button')[0].focus();
				}
			}, 400);
			e.preventDefault();
		} else if (currentElem.classList.contains('step2')) {
			common.FadeOut(document.querySelector(".PD_Step_2"));
			setTimeout(() => {
				common.FadeIn(document.querySelector(".PD_Step_3"));
			}, 400);

			setTimeout(() => {
				detailsSS.ConfigureFocus();
			}, 400);
		}
		else if (currentElem.classList.contains('goToStep2')) {
			common.FadeOut(document.querySelector(".PD_Step_3"));

			setTimeout(() => {
				if (common.BypassImpConfig && prodConfig.IsSingleShipItem) {
					detailsSS.Reset();
				} else {
					common.FadeIn(document.querySelector(".PD_Step_2"));

					setTimeout(() => {
						detailsSS.SetFocus();
					}, 400);
				}

				document.getElementsByClassName('PD_Step_2')[0].scrollIntoView({
					behavior: "smooth"
				});
			}, 400);
			e.preventDefault();
		}
	};

	const waitForTabsToAppear = (activatedTabId) => {
		document.querySelector("#detailTabs").scrollIntoView();
		//allow the tabs to 'appear'
		const callback = function (mutationsList, observer) {
			for (let i = 0; i < mutationsList.length; i++) {
				if (mutationsList[i].type === 'childList') {
					let tab = document.getElementById(activatedTabId);
					tab.click();
					tab.focus();
					tabObserver.disconnect();
				}
			}
		};
		const tabObserver = new MutationObserver(callback);
		tabObserver.observe(document.getElementById('detailTabs'), {
			childList: true,
			subtree: true
		});
	};

	const setUpHashOptions = () => {
		if (document.querySelector("#detailTabs")) {
			switch (window.location.hash) {
				case '#reviews':
					setTimeout(() => {
						waitForTabsToAppear("reviewsTS");
					}, 1200);
					break;
				case '#stories':
					setTimeout(() => {
						waitForTabsToAppear("successStoriesTS");
					}, 1200);
					break;
				case '#fit':
					setTimeout(() => {
						waitForTabsToAppear("fitRatingTS");
					}, 1200);
					break;
				default:
					break;
			}
		}
		if (document.getElementById('InfoType').length > 0 && document.querySelector("#detailTabs")) {
			var InfoType = document.getElementById('InfoType').value;
			switch (InfoType) {
				case '1':
					setTimeout(() => {
						waitForTabsToAppear("reviewsTS");
					}, 1200);
					break;
				case '2':
					setTimeout(() => {
						waitForTabsToAppear("successStoriesTS");
					}, 1200);
					break;
				case '3':
					setTimeout(() => {
						waitForTabsToAppear("fitRatingTS");
					}, 1200);
					break;
			}
		}
	};

	const checkSetEdit = () => {
		if (prodConfig.EditID > 0) {
			var selectedColor = document.getElementById("selectedColorID").value;
			var productColorOptions = [].slice.call(document.getElementsByClassName("selectedColorID"));
			productColorOptions.forEach(function (el, index, array) {
				if (el.value === selectedColor) {
					setTimeout(function () {
						if (el.parentNode.getElementsByTagName("button")[0]) {
							el.parentNode.getElementsByTagName("button")[0].click();
						}
						if (el.parentNode.getElementsByTagName("a")[0]) {
							el.parentNode.getElementsByTagName("a")[0].click();
						}
					}, 1200);
				}
			});
			imprintColorDropdown.KeyEvents();
			var impLocHdrs = document.getElementsByClassName("impLocationCountHeader").length;
			if (document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1] && impLocHdrs > 1) {
				document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1].classList.remove("hide");
				document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1].classList.add("displayFlex", "flexSpaceBetween");
			}
		}
	};

	const getAttributes = () => {
		if (prodConfig.OptionalExtras == null && prodConfig.HasOptionalExtras) prodOptionalExtras.GetOptions();
		if (prodConfig.NibInkOptions == null && prodConfig.HasNonSizingAttributes) prodInkColors.GetOptions();
		if (prodConfig.AdhSidesOptions == null && prodConfig.HasNonSizingAttributes) prodAdhesives.GetOptions();

		if (prodConfig.IsSingleShipItem) {
			detailsSS.GetExtraCharges();
		}
	};

	// click functions
	const scrollToMoreDeets = (e) => {
		e.preventDefault();
		document.querySelector('.prodDetails').scrollIntoView();
		if (document.getElementById("copyTabs")) {
			setTimeout(() => {
				document.getElementById("copyTabs").querySelector("button").focus();
			}, 30);
		}
	};

	const addToCartClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (!document.getElementsByClassName("imprintConfiguration")[0]) {
			document.querySelector('.cartLoadingImg').style.display = "block";
			common.ConfigSectionLoading = true;
			return false;
		}
		if (!processing) {
			processing = true;
			//because of design on mobile, make sure they haven't forgotten to select color / quantity
			if (common.IsMobile || document.getElementsByClassName('bypassImpConfigAddToCart')[0]) {
				if (document.getElementById('colorSelected').value === '' && document.getElementById("productColors").querySelector(".PD_customizeHead")) {
					document.getElementById("productColors").querySelector(".PD_customizeHead").insertAdjacentHTML('afterend', errorMessageBox);
					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
					document.getElementsByClassName("ErrorMsgPanel")[0].classList.add("clear");
					document.getElementById("colorError").focus();
					document.getElementsByClassName("cartLoadingImg")[0].style.display = "none";
					document.getElementById("colorError").addEventListener("click", function (e) {
						e.preventDefault();
						document.querySelector('.imgBox').focus();
					});
					processing = false;
					return false;
				}
				if (common.GetQty() < prodConfig.LowestQuantity) {
					var quantityErrorHtml = '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
						'<ul class="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp textLeft text16 underline textLeft">Minimum quantity for this item is ' + prodConfig.LowestQuantity + '.</button></li></ul></div>';
					if (document.querySelector(".qtyErrorMsg")) {
						document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
					}
					if (prodConfig.IsApparelItem && document.getElementById('PD_SizeGrid')) {
						document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
						var apparelQtys = document.querySelectorAll(".txtApparelQty");
						for (var i = 0; i < apparelQtys.length; i++) {
							if (apparelQtys[i].value != '') {
								apparelQtys[i].classList.add("input-validation-error");
								apparelQtys[i].setAttribute('aria-invalid', 'true');
							}
						}
						document.getElementById("quantityError").focus();
						document.getElementById("quantityError").addEventListener("click", function (e) {
							e.preventDefault();
							apparelQtys[0].focus();
						});
					} else {
						document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
						document.getElementById('txtQty').classList.add("input-validation-error");
						document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
						document.getElementById("quantityError").focus();
						document.getElementById("quantityError").addEventListener("click", function (e) {
							e.preventDefault();
							document.getElementById('txtQty').focus();
						});
					}
					processing = false;
					return false;
				}
			}
			if (!prodConfig.IsSingleShipItem) {
				//forms.formValidation(document.getElementById("step2"), ajaxActions.AddToCart, e);
				forms.formValidation(document.getElementById("step2"), addItemToCart.Send, e);
			} else {
				detailsSS.Validate();
			}
			processing = false;
		}
	};

	const detailsSS = (function () {
		const ssDetails = prodConfig.IsSingleShipItem ? new singleShipDetails() : null;

		const init = () => {
			let ssCustomMsgUploadPage = prodConfig.IsSingleShipItem ? new customMsgUpload4i() : null;

			ssDetails.Init();
			ssCustomMsgUploadPage.Init(storageContainerName, blobStorageUri);

			let ssSelectedInsertSize = [].slice.call(document.getElementsByName("ShippingList.CustomMessage.SelectedInsertSize"));
			ssSelectedInsertSize.forEach(function (el) {
				el.addEventListener("keydown", function (e) {
					if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && !e.shiftKey)
						document.getElementById("noFlyer").focus();
				});
			});

			if (document.getElementById("ssBoxesToSend")) {
				document.getElementById("ssBoxesToSend").addEventListener("change", function () {
					ssDetails.FormEvents.ClearAddlFormValidation();
					forms.ClearValidation();
					var selectedQuantity = parseInt(document.getElementById("ssBoxesToSend")[document.getElementById("ssBoxesToSend").selectedIndex].value);
					ssDetails.FormEvents.ConfigureShipToMeSection(selectedQuantity);
					common.GetExtrasAmount();
					ssDetails.FormEvents.ValidateSSOptions();
				});
			}

			if (document.getElementById("btnConfigureSSBoxes"))
				document.getElementById("btnConfigureSSBoxes").addEventListener("click", configure);
		},
			validate = (e) => {
				if (common.IsMobile) {
					forms.formValidation(document.getElementById("step2"), validateMobile, e);
				} else {
					//forms.formValidation(document.getElementById("step3"), ajaxActions.AddToCart, e, ssDetails.FormEvents.AddlFormValidation);
					forms.formValidation(document.getElementById("step3"), addItemToCart.Send, e, ssDetails.FormEvents.AddlFormValidation);
				}
			},
			validateMobile = (e) => {
				//forms.formValidation(document.getElementById("step3"), ajaxActions.AddToCart, e, ssDetails.FormEvents.AddlFormValidation);
				forms.formValidation(document.getElementById("step3"), addItemToCart.Send, e, ssDetails.FormEvents.AddlFormValidation);
			},
			configure = (e) => {
				if (common.BypassImpConfig) {
					goToNextStep(e);
				} else {
					e.preventDefault();
					e.stopPropagation();
					forms.formValidation(document.getElementById("step2"), function (e) { goToNextStep(e); }, e);
				}
			},
			hideBoxes = () => {
				document.getElementsByClassName("btnConfigureSSBoxes")[0].classList.add("hide");
				document.getElementsByClassName("btnConfigureSSBoxes")[0].classList.remove("button-lg");
				document.getElementsByClassName("alertBox")[0].classList.add("hide");
				document.getElementsByClassName("PD_Step_3")[0].classList.remove("hide");
				if (!common.BypassImpConfig) {
					document.getElementsByClassName("orderInformation")[0].classList.add("hide");
				}
			},
			disable = () => {
				document.getElementsByClassName("btnConfigureSSBoxes")[0].disabled = false;
			},
			configureBoxes = () => {
				if (document.getElementsByClassName("quantitySummary")[0]) {
					document.getElementsByClassName("quantitySummary")[0].innerHTML = common.GetQty();
				}
				common.FadeIn(document.querySelector(".PD_Step_3"));
				configureFocus();
			},
			enableBtn = () => {
				document.querySelector("#btnConfigureSSBoxes").classList.add('bkgdBlue');
				document.querySelector("#btnConfigureSSBoxes").classList.add('whiteLink');
				document.querySelector("#btnConfigureSSBoxes").classList.remove('disabledBtn');
				document.querySelector("#btnConfigureSSBoxes").classList.remove('bkgdMdGray');
			},
			setUp = () => {
				ssDetails.FormEvents.ConfigureSSBoxesSection();
				if (document.getElementsByClassName("imprintConfiguration")[0]) common.GetExtrasAmount();
			},
			reset = () => {
				common.FadeIn(document.querySelector(".step1Color"));
				common.FadeIn(document.querySelector(".step1Qty"));

				setTimeout(() => {
					ssDetails.FormEvents.ClearAddlFormValidation();
					forms.ClearValidation();
					if (document.getElementById("jumpToColor")) {
						document.getElementById("jumpToColor").focus();
					} else if (document.querySelector('.PD_Step_1').getElementsByTagName('a')[0]) {
						document.querySelector('.PD_Step_1').getElementsByTagName('a')[0].focus();
					} else {
						document.querySelector('.PD_Step_1').getElementsByTagName('button')[0].focus();
					}
				}, 400);
			},
			getExtraCharges = () => {
				if (document.querySelector(".pricePerBox").innerHTML == "") {
					if (prodConfig.IsApparelItem) {
						ssDetails.AjaxActions.GetSingleShipExtraCharge(prodConfig.LowestQuantity);
					} else {
						ssDetails.AjaxActions.GetSingleShipExtraCharge(qty);
					}
				}
			},
			configureFocus = () => {
				document.getElementById("ssBoxesToSend").focus();
				ssDetails.FormEvents.ConfigureSSBoxesSection();
				common.GetExtrasAmount();
			},
			setFocus = () => {
				ssDetails.FormEvents.ClearAddlFormValidation();
				forms.ClearValidation();
				if (document.getElementsByClassName("selImprintLocation")[0] && !document.getElementsByClassName("selImprintLocation")[0].disabled) {
					document.getElementsByClassName("selImprintLocation")[0].focus();
				} else if (document.getElementsByClassName("prodColorOptions")[0] && !document.getElementsByClassName("prodColorOptions")[0].classList.contains("disabledColorSelect")) {
					document.getElementsByClassName("prodColorOptions")[0].focus();
				} else {
					document.getElementsByClassName("goToStep1")[0].focus();
				}
			};
		return {
			Init: init,
			Validate: validate,
			HideBoxes: hideBoxes,
			Disable: disable,
			ConfigureBoxes: configureBoxes,
			EnableBtn: enableBtn,
			SetUp: setUp,
			Reset: reset,
			GetExtraCharges: getExtraCharges,
			ConfigureFocus: configureFocus,
			SetFocus: setFocus
		};
	})();

	init();

	(function waitAndFixAddToCart(retries = 0) {
		const colorDesc = document.querySelector('.colorOptionDesc')?.textContent?.toLowerCase() || '';
		const imprintColorID = document.querySelector('input.imprintColorID')?.value || '';
		const btn = document.querySelector('.btnAddToCart');

		if (colorDesc === 'full color' && imprintColorID !== '') {
			btn?.classList.remove('disabledBtn', 'bkgdMdGray');
			btn?.classList.add('bkgdGreen', 'darkestLink');
		} else if (retries < 15) {
			setTimeout(() => waitAndFixAddToCart(retries + 1), 300);
		}
	})();

})();